export function salvarAtividades(atividades) {
  return {
    type: '@atividades/SALVAR',
    payload: { atividades },
  };
}
